import { render, staticRenderFns } from "./NewDocumentSignView.vue?vue&type=template&id=6f532628&scoped=true&"
import script from "./NewDocumentSignView.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentSignView.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentSignView.vue?vue&type=style&index=0&id=6f532628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f532628",
  null
  
)

export default component.exports